export const APIList = {
  createUser: "user/createUser",
  verifyOtp: "user/verifyOtp",
  getPartnerData: "api/v1/user/getPartnerDetails",
  allPolicies: "policy?source=kyp",
  getBenefitSummary: "app/v1/getBenefitsSummary",
  getHealthQuality: "app/v2/healthQuality/get",
  getHealthQualityResult: "app/v1/healthQualityResult",
  couponCheck: "coupon/check",
  kypTransaction: "transaction/kyp",
  getSinglePolicy: "policy/getById",
  postHealthQualityResult: "app/v1/healthQuality/result",
  uploadPolicy: "policy/v3",
  getUserProfile: "user/profile",
  getPolicyDetails: "policy/getPolicyDocEyeData/",
  getQuestions: "app/v1/questions/",
  postQualityCheck: "app/v1/qualityCheck",
  policy: "policy",
  lifeResult: "app/qualityCheck/result",
  getMotorPreview: "motorKyp/getPolicyPreview",
  getMotorReviewData: "motorKyp/reviewScreen",
  submitReviewData: "motorKyp/submit-user-input",
  getMotorBenefitSummary: "motorKyp/benefit-summary",
  getMotorKypResult: "motorkyp/getKypResult",

  // Recommendation Engine APIs
  getAllrecommendationCompanies: "insa-recommendation/companies",
  getProductsByCompany: (companyId: string) => `insa-recommendation/companies/${companyId}/products`,
  getProductsDataByProductId: (productId: string) => `insa-recommendation/products/${productId}`
};
